import { render, staticRenderFns } from "./ScheduleLevels.vue?vue&type=template&id=531c2946&scoped=true&"
import script from "./ScheduleLevels.vue?vue&type=script&lang=js&"
export * from "./ScheduleLevels.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleLevels.vue?vue&type=style&index=0&id=531c2946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c2946",
  null
  
)

export default component.exports